import * as React from "react";
//utils
import { DisableButton } from "utils/DisableButton";
//components
import { Button } from "components/Button";
//assets
import editIcon from 'img/edit-icon-table.svg';
import confirmIcon from 'img/confirm-icon.svg';
import blockedIcon from 'img/icon-item-blocked.svg';
//interface
import { CancelIconProps, EditIconProps, IConfirmIcon } from "./interface";

export const ConfirmIcon = (props: IConfirmIcon) => {
  const { onClick, disabled, className, dataTestid, showTip, tipContent } = props;

  return (
    <Button
      className={className}
      disabled={disabled}
      data-testid={dataTestid}
      onClick={onClick}
      tooltip={showTip ? tipContent : undefined}
    >
      <img src={confirmIcon} />
    </Button>
  );
};

export const CancelIcon = (props: CancelIconProps) => {
  const { className, dataTestId, disabled, onClick, tooltip } = props;

  return (
    <Button
      data-testid={dataTestId}
      onClick={() => !disabled && onClick()}
      tooltip={tooltip}
      className={`${(className)}`}
    >
      <img src={blockedIcon} />
    </Button>
  );
};

export const EditIcon = (props: any) => {
  return (
    <svg width={16}
      height={16}
      fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.74658 8.90057L12.0444 1.60254L14.398 3.95615L7.10019 11.2542L4.74658 8.90057Z" fill={props.color} />
      <path d="M3.55566 12.4447L6.15664 11.7243L4.2761 9.84375L3.55566 12.4447Z" fill={props.color} />
      <path d="M15.0472 0.365341C14.5589 -0.12178 13.7684 -0.12178 13.2801 0.365341L12.75 0.895415L15.1036 3.24902L15.6337 2.71895C16.121 2.23065 16.121 1.44013 15.6337 0.951839L15.0472 0.365341Z" fill={props.color} />
      <path d="M0 2.66667C0 1.19391 1.19391 0 2.66667 0H8C8.49092 0 8.88889 0.397969 8.88889 0.888889C8.88889 1.37981 8.49092 1.77778 8 1.77778H2.66667C2.17575 1.77778 1.77778 2.17575 1.77778 2.66667V13.3333C1.77778 13.8243 2.17575 14.2222 2.66667 14.2222H13.3333C13.8243 14.2222 14.2222 13.8243 14.2222 13.3333V8C14.2222 7.50908 14.6202 7.11111 15.1111 7.11111C15.602 7.11111 16 7.50908 16 8V13.3333C16 14.8061 14.8061 16 13.3333 16H2.66667C1.19391 16 0 14.8061 0 13.3333V2.66667Z" fill={props.color} />
    </svg>
  );
};

export const EditIconTooltip = (props: EditIconProps) => {
  const { showTip, showTipContent, onClick, disabled } = props;

  return (
    <Button
      html={true}
      data-testid={'btn-edit-input'}
      onClick={() => !disabled && onClick()}
      tooltip={showTip ? showTipContent : undefined}
      className={`btnEdit mr-3 ${DisableButton(disabled)}`}
    >
      <img src={editIcon} />
    </Button>
  );
}


